import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'check-thin-icon',
  templateUrl: './check-thin-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class CheckThinIconComponent {}
